import React, { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { createInventoriesAction } from '../../../store/inventory'
import { Form, Input } from 'antd'
import { OPERATION_SALE } from '../constants'
import InventoryOperationModalForm from './InventoryOperationModalForm'
import DecimalInput from '../../DecimalInput'

const { TextArea } = Input

const SaleInventoryOperationModal = ({ equipmentIds, showModal, onCancel, onFinish }) => {
  const dispatch = useDispatch()

  const onFinishAction = useCallback(
    async (data) => {
      let result = await dispatch(
        createInventoriesAction({
          ...data,
          type: OPERATION_SALE,
          equipments: equipmentIds,
        })
      ).unwrap()
      onFinish(equipmentIds)
      return result
    },
    [dispatch, equipmentIds]
  )

  return (
    <InventoryOperationModalForm
      title="Карточка операции продажи"
      formName="sale-inventory-operation"
      messageKey="sale_inventory"
      showModal={showModal}
      onFinish={onFinishAction}
      onCancel={onCancel}
    >
      <Form.Item
        label="Цена"
        name="sale_price"
        labelCol={{ span: 24 }}
        rules={[{ required: true, message: 'Поле обязательно' }]}
      >
        <DecimalInput />
      </Form.Item>
      <Form.Item name="comment" label="Комментарий" labelCol={{ span: 24 }}>
        <TextArea rows={4} />
      </Form.Item>
    </InventoryOperationModalForm>
  )
}

export default SaleInventoryOperationModal
